import { combineReducers } from 'redux';

import permissionGroups from './permissionGroups/reducer';
import connectedModal from './connectedModal/reducer';
import restaurants from './restaurants/reducer';
import permissions from './permissions/reducer';
import itemsSold from './itemsSold/reducer';
import invoices from './invoices/reducer';
import metrics from './metrics/reducer';
import request from './request/reducer';
import session from './session/reducer';
import orders from './orders/reducer';
import users from './users/reducer';
import offers from './offers';
import notifications from './notifications/reducer';
import purchasing from './purchasing/reducer';
import banking from './banking/reducer';
import reports from './reports/reducer';
import liveOrders from './liveOrders/reducer';
import settings from './settings/reducer';
import refunds from './refunds/reducer';
import reviews from './reviews/reducer';
import ratings from './ratings/reducer';
import deliveryAreas from './deliveryAreas/reducer';
import lifecycle from './lifecycle/reducer';
import dataFilters from './dataFilters/reducer';
import openingHours from './openingHours/reducer';
import romPassword from './romPassword/reducer';
import payments from './payments/reducer';
import intercom from './intercom/reducer';
import campaigns from './campaigns/reducer';
import rewards from './rewards/reducer';
import metricThresholds from './metricThresholds/reducer';
import frontOfHouse from './frontOfHouse/reducer';
import signup from './signup/reducer';
import integrations from './integrations/reducer';
import bagFees from './bagFees/reducer';
import customers from './customers/reducer';
import reportingPlatform from './reportingPlatform/reducer';
import marketer from './marketer/reducer';
import daysOff from './daysOff/reducer';
import fleetSwitching from './fleetSwitching/reducer';
import refundDisputes from './refundDisputes/reducer';
import apiGWAllowedList from './apiGateway/reducer';
import siteStatus from './siteStatus/reducer';

export default combineReducers({
  permissionGroups,
  connectedModal,
  permissions,
  restaurants,
  itemsSold,
  invoices,
  session,
  request,
  orders,
  metrics,
  users,
  offers,
  notifications,
  purchasing,
  banking,
  reports,
  liveOrders,
  settings,
  refunds,
  reviews,
  ratings,
  deliveryAreas,
  lifecycle,
  dataFilters,
  openingHours,
  romPassword,
  payments,
  intercom,
  campaigns,
  rewards,
  metricThresholds,
  frontOfHouse,
  signup,
  integrations,
  bagFees,
  customers,
  reportingPlatform,
  marketer,
  daysOff,
  fleetSwitching,
  refundDisputes,
  apiGWAllowedList,
  siteStatus,
});
